var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5C9.27614 5.5 9.5 5.27614 9.5 5C9.5 4.72386 9.27614 4.5 9 4.5C8.72386 4.5 8.5 4.72386 8.5 5C8.5 5.27614 8.72386 5.5 9 5.5Z",
    fill: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5C15.27614 5.5 15.5 5.27614 15.5 5C15.5 4.72386 15.27614 4.5 15 4.5C14.72386 4.5 14.5 4.72386 14.5 5C14.5 5.27614 14.72386 5.5 15 5.5Z",
    fill: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5C9.27614 12.5 9.5 12.27614 9.5 12C9.5 11.72386 9.27614 11.5 9 11.5C8.72386 11.5 8.5 11.72386 8.5 12C8.5 12.27614 8.72386 12.5 9 12.5Z",
    fill: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5C15.27614 12.5 15.5 12.27614 15.5 12C15.5 11.72386 15.27614 11.5 15 11.5C14.72386 11.5 14.5 11.72386 14.5 12C14.5 12.27614 14.72386 12.5 15 12.5Z",
    fill: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5C9.27614 19.5 9.5 19.27614 9.5 19C9.5 18.72386 9.27614 18.5 9 18.5C8.72386 18.5 8.5 18.72386 8.5 19C8.5 19.27614 8.72386 19.5 9 19.5Z",
    fill: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.5C15.27614 19.5 15.5 19.27614 15.5 19C15.5 18.72386 15.27614 18.5 15 18.5C14.72386 18.5 14.5 18.72386 14.5 19C14.5 19.27614 14.72386 19.5 15 19.5Z",
    fill: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDots);
export default __webpack_public_path__ + "static/media/drag-dots.4b90a36987e197c35d4e24778140dc17.svg";
export { ForwardRef as ReactComponent };